/**
 * Session helpers: the authenticated state lives in a tiny pubsub.
 * After unlock, we keep the bearer token in memory only (set on the
 * apiClient via setBearerToken) and surface user info to the UI.
 */
import type { UnlockedSession } from '@argos/auth-client';
import { setBearerToken } from '../api/client';

let _session: UnlockedSession | null = null;
const _listeners = new Set<(s: UnlockedSession | null) => void>();

export function getSession(): UnlockedSession | null {
  return _session;
}

export function setSession(s: UnlockedSession | null): void {
  _session = s;
  setBearerToken(s?.bearer_token ?? null);
  for (const fn of _listeners) {
    try {
      fn(s);
    } catch {
      /* swallow listener errors — pubsub failures shouldn't break auth */
    }
  }
}

export function subscribeSession(fn: (s: UnlockedSession | null) => void): () => void {
  _listeners.add(fn);
  return () => _listeners.delete(fn);
}
